module.exports = __webpack_public_path__ + "static/Carly_Daniel14-0f38e5e606a923743e101b7e9146cd34.jpg";